import { render, staticRenderFns } from "./tzproduct5.vue?vue&type=template&id=1fc0b46c&scoped=true"
import script from "./tzproduct5.vue?vue&type=script&lang=js"
export * from "./tzproduct5.vue?vue&type=script&lang=js"
import style0 from "./tzproduct5.vue?vue&type=style&index=0&id=1fc0b46c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc0b46c",
  null
  
)

export default component.exports